window.bundleDataG = {
"Gabriel-boy": {
displayName: "Gabriel",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Gabriel Personalized Coloring Experience",
variantId: "49343623135469",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Gabriel_final_cover.png?v=1772469698",
price: "$14.99",
preorder: true
},
{
title: "Gabriel Dragon Holographic Sticker",
variantId: "49933771342061",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Gabriel_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Gabriel Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Gabriella-girl": {
displayName: "Gabriella",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Gabriella Personalized Coloring Experience",
variantId: "49279569002733",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Gabriella_final_cover.png?v=1773766536",
price: "$14.99",
preorder: true
},
{
title: "Gabriella Unicorn Holographic Sticker",
variantId: "49933775831277",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Gabriella_holographic_sticker.png?v=1779489479",
price: "$4.99",
preorder: false
},
{
title: "Gabriella Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Gael-boy": {
displayName: "Gael",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Gael Personalized Coloring Experience",
variantId: "49343624970477",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Gael_final_cover.png?v=1772469698",
price: "$14.99",
preorder: true
},
{
title: "Gael Dragon Holographic Sticker",
variantId: "49933771309293",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Gael_holographic_sticker.png?v=1779648203",
price: "$4.99",
preorder: false
},
{
title: "Gael Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Gavin-boy": {
displayName: "Gavin",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Gavin Personalized Coloring Experience",
variantId: "49343626412269",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Gavin_final_cover.png?v=1772469698",
price: "$14.99",
preorder: true
},
{
title: "Gavin Dragon Holographic Sticker",
variantId: "49933771276525",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Gavin_holographic_sticker.png?v=1779648203",
price: "$4.99",
preorder: false
},
{
title: "Gavin Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Genesis-girl": {
displayName: "Genesis",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Genesis Personalized Coloring Experience",
variantId: "49508296458477",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Genesis_final_cover.png?v=1773105080",
price: "$14.99",
preorder: true
},
{
title: "Genesis Unicorn Holographic Sticker",
variantId: "49933758103789",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Genesis_holographic_sticker.png?v=1779489479",
price: "$4.99",
preorder: false
},
{
title: "Genesis Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Genevieve-girl": {
displayName: "Genevieve",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Genevieve Personalized Coloring Experience",
variantId: "49945819709677",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Genevievefinalcover.png?v=1778360405",
price: "$14.99",
preorder: true
},
{
title: "Genevieve Unicorn Holographic Sticker",
variantId: "49945794314477",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Genevieve_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Genevieve Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"George-boy": {
displayName: "George",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "George Personalized Coloring Experience",
variantId: "49343627034861",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/George_final_cover.png?v=1772469700",
price: "$14.99",
preorder: true
},
{
title: "George Dragon Holographic Sticker",
variantId: "49933771243757",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/George_holographic_sticker.png?v=1779648210",
price: "$4.99",
preorder: false
},
{
title: "George Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Gianna-girl": {
displayName: "Gianna",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Gianna Personalized Coloring Experience",
variantId: "49508306354413",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Gianna_final_cover.png?v=1773105080",
price: "$14.99",
preorder: true
},
{
title: "Gianna Unicorn Holographic Sticker",
variantId: "49933758038253",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Gianna_holographic_sticker.png?v=1779489478",
price: "$4.99",
preorder: false
},
{
title: "Gianna Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Giovanni-boy": {
displayName: "Giovanni",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Giovanni Personalized Coloring Experience",
variantId: "49343627821293",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Giovanni_final_cover.png?v=1771691712",
price: "$14.99",
preorder: true
},
{
title: "Giovanni Dragon Holographic Sticker",
variantId: "49933771210989",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Giovanni_holographic_sticker.png?v=1779648215",
price: "$4.99",
preorder: false
},
{
title: "Giovanni Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Giselle-girl": {
displayName: "Giselle",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Giselle Personalized Coloring Experience",
variantId: "49508317593837",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Giselle_final_cover.png?v=1773105079",
price: "$14.99",
preorder: true
},
{
title: "Giselle Unicorn Holographic Sticker",
variantId: "49933757939949",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Giselle_holographic_sticker.png?v=1779489479",
price: "$4.99",
preorder: false
},
{
title: "Giselle Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Grace-girl": {
displayName: "Grace",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Grace Personalized Coloring Experience",
variantId: "49508354883821",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Grace_final_cover.png?v=1773105080",
price: "$14.99",
preorder: true
},
{
title: "Grace Unicorn Holographic Sticker",
variantId: "49933757907181",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Grace_holographic_sticker.png?v=1779489479",
price: "$4.99",
preorder: false
},
{
title: "Grace Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Graham-boy": {
displayName: "Graham",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Graham Personalized Coloring Experience",
variantId: "49274738966765",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Graham_final_cover.png?v=1772469697",
price: "$14.99",
preorder: true
},
{
title: "Graham Dragon Holographic Sticker",
variantId: "49933780353261",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Graham_holographic_sticker.png?v=1779648215",
price: "$4.99",
preorder: false
},
{
title: "Graham Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Grant-boy": {
displayName: "Grant",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Grant Personalized Coloring Experience",
variantId: "49412016046317",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/GRANT_FINAL_COVER.png?v=1772032668",
price: "$14.99",
preorder: true
},
{
title: "Grant Dragon Holographic Sticker",
variantId: "49933766557933",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Grant_holographic_sticker.png?v=1779648203",
price: "$4.99",
preorder: false
},
{
title: "Grant Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Grayson-boy": {
displayName: "Grayson",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Grayson Personalized Coloring Experience",
variantId: "49279569101037",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Grayson_final_cover_5910afba-692e-4af8-b31a-0d83f93ffd33.png?v=1772483898",
price: "$14.99",
preorder: true
},
{
title: "Grayson Dragon Holographic Sticker",
variantId: "49933775765741",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Grayson_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Grayson Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Greyson-boy": {
displayName: "Greyson",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Greyson Personalized Coloring Experience",
variantId: "49343629066477",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Greyson_final_cover.png?v=1772483899",
price: "$14.99",
preorder: true
},
{
title: "Greyson Dragon Holographic Sticker",
variantId: "49933771178221",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Greyson_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Greyson Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Georgia-girl": {
displayName: "Georgia",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Georgia Personalized Coloring Experience",
variantId: "50078266294509",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Georgia_final_cover.png?v=1780809444",
price: "$14.99",
preorder: true
},
{
title: "Georgia Unicorn Holographic Sticker",
variantId: "50077630595309",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Georgia_sticker_website.png?v=1780804205",
price: "$4.99",
preorder: false
},
{
title: "Georgia Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Gemma-girl": {
displayName: "Gemma",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Gemma Personalized Coloring Experience",
variantId: "50305418133741",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Gemmafinalcover.png?v=1784424114",
price: "$14.99",
preorder: true
},
{
title: "Gemma Unicorn Holographic Sticker",
variantId: "50305508114669",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Gemma_holographic_sticker.png?v=1784431196",
price: "$4.99",
preorder: false
},
{
title: "Gemma Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Griffin-boy": {
displayName: "Griffin",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Griffin Personalized Coloring Experience",
variantId: "50399180652781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Griffin_final_cover.png?v=1784947222",
price: "$14.99",
preorder: true
},
{
title: "Griffin Dragon Holographic Sticker",
variantId: "50399540412653",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Griffin_holographic_sticker.png?v=1784945963",
price: "$4.99",
preorder: false
},
{
title: "Griffin Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Gracie-girl": {
displayName: "Gracie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Gracie Personalized Coloring Experience",
variantId: "50595104358637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Gracie_final_cover.png?v=1788159623",
price: "$14.99",
preorder: true
},
{
title: "Gracie Unicorn Holographic Sticker",
variantId: "50604076990701",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Gracie_holographic_sticker.png?v=1788224572",
price: "$4.99",
preorder: false
},
{
title: "Gracie Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} 






};